import ForecastIcon from '@/components/ForecastIcon';
import { QuarteredForecastPart } from '@/models/QuarteredForecastPart';

type QuarterTemperatureProps = Pick<QuarteredForecastPart, 'icon' | 'temperature' | 'feelTemperature' | 'description'>;

const QuarterTemperature = ({ icon, temperature, feelTemperature, description }: QuarterTemperatureProps) => (
  <div className="mb-3.5 lg:mb-0 lg:w-full">
    <div className="mb-1.5 flex items-center lg:mb-0">
      <div className="flex lg:basis-[66%] lg:items-center lg:pl-4.5 xl:mr-6 xl:basis-[71%]">
        <div className="pt-0.5 lg:ml-2.5 lg:flex lg:items-center lg:pt-0">
          <ForecastIcon iconName={icon} className="h-[30px] w-[30px] shrink-0 lg:h-10 lg:w-10" alt={description} />
          <span className="ml-2.5 hidden text-sm text-grey-900 xl:block xl:pt-0.5">{description}</span>
        </div>
        <span className="ml-2 shrink-0 text-lg font-medium lg:order-first lg:ml-0 lg:basis-[42px] lg:text-xl xl:basis-[46px] xl:self-start xl:pb-0.5 xl:leading-9">
          {temperature}&deg;
        </span>
      </div>
      <div className="ml-1 text-xs font-medium text-blue-grey-500 lg:ml-0">
        <span className="lg:hidden">Ощущается как </span>
        <span className="lg:text-base lg:font-medium lg:text-grey-900 xl:text-lg xl:leading-4">
          {feelTemperature}&deg;
        </span>
      </div>
    </div>
    <div className="text-sm text-grey-800 lg:hidden">{description}</div>
  </div>
);

export default QuarterTemperature;
